import { render } from "./AnnouncementCard.vue?vue&type=template&id=2594ea04"
import script from "./AnnouncementCard.vue?vue&type=script&lang=js"
export * from "./AnnouncementCard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__